"use client"

import React, { useEffect, useRef } from "react"
import TC_Wrapper from "react-tag-commander"

import { sanitizeRichText } from "@/lib/sanitizeHtml"
import { buildAnalyticsLinks, cn } from "@/lib/utils"

type WysiwygSimpleProps = {
  data: string | TrustedHTML
  className?: string
}

const WysiwygSimple = ({ data, className }: WysiwygSimpleProps) => {
  const tcWrapper = TC_Wrapper.getInstance()
  const wysiwygRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (data) {
      const tables = wysiwygRef?.current?.querySelectorAll("table")

      tables?.forEach((table) => {
        const firstRow = table.querySelector("tr")

        if (firstRow) {
          const cells = firstRow.querySelectorAll("td")

          if (cells.length === 2) {
            ;(table as HTMLElement).style.setProperty(
              "padding-right",
              "0",
              "important"
            )
            ;(table as HTMLElement).style.setProperty(
              "padding-left",
              "0",
              "important"
            )

            const tableFadeParent = table.closest(".table-fade")
            if (tableFadeParent) {
              const tableFadeParentElement = tableFadeParent as HTMLElement
              tableFadeParentElement.classList.add("hide-after")
            }
          }
        }
      })
    }
  }, [data])

  useEffect(() => {
    const handleLinkClick = (event: MouseEvent) => {
      const link = (event.target as HTMLElement).closest("a")
      if (!link) return
      try {
        const linkUrl = new URL(link.href, document.baseURI)
        const analytics = buildAnalyticsLinks([link.text], linkUrl, undefined)
        tcWrapper.triggerEvent(
          analytics.type,
          event.currentTarget,
          analytics.chapters
        )
      } catch (error) {
        console.error("Invalid URL", error)
      }
    }

    const currentRef = wysiwygRef.current
    if (!currentRef) return
    currentRef.addEventListener("click", handleLinkClick)

    return () => {
      currentRef.removeEventListener("click", handleLinkClick)
    }
  }, [tcWrapper, wysiwygRef])

  return (
    <div
      ref={wysiwygRef}
      className={cn("wysiwyg-simple", className)}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(String(data)) }}
    />
  )
}

export default WysiwygSimple
